import { useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { getCityList, selectCityList, selectDetectedCity } from 'entities/City/City.slice';
import { sortCityListByDetectedCity } from 'entities/City/City.helper';
import { ICityCollectionParams } from 'entities/City/City.models';
import { selectCurrentUser, updateUser } from 'entities/User/User.slice';

const cityListParams: ICityCollectionParams = { limit: 0 };

export const useSelectCityModal = () => {
  const dispatch = useAppDispatch();
  // city
  const cityList = useAppSelector(selectCityList);
  const detectedCity = useAppSelector(selectDetectedCity);
  // user
  const currentUser = useAppSelector(selectCurrentUser);

  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const sortedCityList = useMemo(() => sortCityListByDetectedCity(cityList, detectedCity), [cityList, detectedCity]);

  const openSelectCityModal = async (): Promise<void> => {
    await dispatch(getCityList(cityListParams));
    setOpen(true);
  };

  const closeSelectCityModal = (): void => {
    setOpen(false);
  };

  const updateUserCity = async (cityId: number, onSuccess: () => void): Promise<void> => {
    if (!currentUser) {
      return;
    }

    setLoading(true);
    await dispatch(updateUser({ id: currentUser.id, cityId, onSuccess }));
    setLoading(false);
  };

  return {
    openSelectCityModal,
    props: {
      open,
      loading,
      items: sortedCityList,
      userCity: currentUser?.city,
      detectedCityId: detectedCity?.id,
      onCancel: closeSelectCityModal,
      onSubmit: updateUserCity,
    },
  };
};

export const CityHooks = { useSelectCityModal };
